import axios from 'axios';
import React from 'react';
import { InjectedTranslateProps } from 'react-i18next';
import { notifyViewStartLoading, TModuleParams } from '@wix/business-manager-api';
import { wixAxiosConfig } from '@wix/wix-axios-config';
import { ExperimentsProvider } from '@wix/wix-experiments-react';
import { COMPONENT_NAME } from './config';
import { App } from '@src/components/App';
import { PrivacyCenterScope } from '@src/constants';
import { StoreProvider, RootProps } from './context/store';
import { BrowserRouter as Router } from 'react-router-dom';
import { DataHooks } from './constants/data-hooks';
import { NavigationStoreProvider } from './context/navigation-store/navigation-store';
import { initLogger } from '@src/sevices/bi-logger/bi-logger-service';

wixAxiosConfig(axios, {
  baseURL: '/',
});

export interface Props extends TModuleParams, InjectedTranslateProps {
  routeBaseName: string;
}

export default class AppContainer extends React.PureComponent<Props> {
  constructor(props: Props) {
    super(props);
    notifyViewStartLoading(COMPONENT_NAME);
  }

  render() {
    const { accountLanguage, config, liveSite, viewMode } = this.props;
    const { translationsStaticsUrl } = config.topology;
    const { routeBaseName, metaSiteId } = this.props;
    const rootPath = `${routeBaseName}${metaSiteId}/${COMPONENT_NAME}`;

    initLogger(metaSiteId);

    const rootProps: RootProps = {
      viewMode,
      liveSite,
      msid: metaSiteId,
      accountLanguage,
      translationsStaticsUrl,
    };

    return (
      <ExperimentsProvider scope={PrivacyCenterScope}>
        <StoreProvider {...rootProps}>
          <Router data-hook={DataHooks.App} basename={rootPath}>
            <NavigationStoreProvider>
              <App />
            </NavigationStoreProvider>
          </Router>
        </StoreProvider>
      </ExperimentsProvider>
    );
  }
}
